import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import TabModelo from "./TabModelo";

import rebelAzul from "../../assets/img/rampage/rebel/rebel-azul.png";
import rebelBranco from "../../assets/img/rampage/rebel/rebel-branco.png";
import rebelCinza from "../../assets/img/rampage/rebel/rebel-cinza.png";
import rebelDiamond from "../../assets/img/rampage/rebel/rebel-diamond.png";
import rebelPrata from "../../assets/img/rampage/rebel/rebel-prata.png";
import rebelRojo from "../../assets/img/rampage/rebel/rebel-rojo.png";
import rebelSteel from "../../assets/img/rampage/rebel/rebel-steel.png";

import rtAzul from "../../assets/img/rampage/rt/rt-azul.png";
import rtBranco from "../../assets/img/rampage/rt/rt-branco.png";
import rtCinza from "../../assets/img/rampage/rt/rt-cinza.png";
import rtDiamond from "../../assets/img/rampage/rt/rt-diamond.png";
import rtPrata from "../../assets/img/rampage/rt/rt-prata.png";
import rtRojo from "../../assets/img/rampage/rt/rt-rojo.png";
import rtSteel from "../../assets/img/rampage/rt/rt-steel.png";

import laramieAzul from "../../assets/img/rampage/laramie/laramie-azul.png";
import laramieBranco from "../../assets/img/rampage/laramie/laramie-branco.png";
import laramieCinza from "../../assets/img/rampage/laramie/laramie-cinza.png";
import laramieDiamond from "../../assets/img/rampage/laramie/laramie-diamond.png";
import laramiePrata from "../../assets/img/rampage/laramie/laramie-prata.png";
import laramieRojo from "../../assets/img/rampage/laramie/laramie-rojo.png";
import laramieSteel from "../../assets/img/rampage/laramie/laramie-steel.png";

import nightAzul from "../../assets/img/rampage/night/night-azul.png";
import nightBlanco from "../../assets/img/rampage/night/night-blanco.png";
import nightgris from "../../assets/img/rampage/night/night-gris.png";
import nightNegro from "../../assets/img/rampage/night/night-negro.png";
import nightPlata from "../../assets/img/rampage/night/night-plata.png";

import { useEffect, useState } from "react";

export const colores = {
  azul: "#0785da",
  blanco: "#e0e0dc",
  gris: "#6c7e8c",
  negro: "#000000",
  rojo: "#B30101",
  plata: "#C7C6C4",
  grisOscuro: "#32343B",
};

const Modelos = () => {
  const models = [
    {
      modelo: "REBEL",
      id: "REBEL",
      types: [
        {
          title: "REBEL",
          specs: [
            "Motorización Hurricane4 2.0 Turbo 272Cv | 400 Nm",
            "Transmisión Automática de 9 velocidades",
            "Tracción integral 4X4",
            "Interior tapizado de cuero",
            "Rodado 17''",
            "Parrilla frontal negra",
          ],
          colores: [
            { file: rebelAzul, color: colores.azul },
            { file: rebelBranco, color: colores.blanco },
            { file: rebelDiamond, color: colores.negro },
            { file: rebelCinza, color: colores.gris },
            { file: rebelPrata, color: colores.plata },
            { file: rebelRojo, color: colores.rojo },
            { file: rebelSteel, color: colores.grisOscuro },
          ],
        },
      ],
      ficha: "https://montironijeep.com/wp-content/uploads/2024/01/Rampage-Rebel-1.pdf",
    },
    {
      modelo: "RT",
      id: "RT",
      types: [
        {
          title: "RT",
          specs: [
            "Motorización Hurricane4 2.0 Turbo 272Cv | 400 Nm",
            "Transmisión Automática de 9 velocidades",
            "Tracción integral 4X4",
            "Interior tapizado de cuero",
            "Llantas Rodado 19' Gloss Black",
            "Parrilla frontal Sport R/T",
          ],
          colores: [
            { file: rtAzul, color: colores.azul },
            { file: rtBranco, color: colores.blanco },
            { file: rtDiamond, color: colores.negro },
            { file: rtCinza, color: colores.gris },
            { file: rtPrata, color: colores.plata },
            { file: rtRojo, color: colores.rojo },
            { file: rtSteel, color: colores.grisOscuro },
          ],
        },
      ],
      ficha: "https://montironijeep.com/wp-content/uploads/2024/01/Rampage-RT.pdf",
    },
    {
      modelo: "LARAMIE",
      id: "LARAMIE",
      types: [
        {
          title: "LARAMIE",
          specs: [
            "Motorización Hurricane4 2.0 Turbo 272Cv | 400 Nm",
            "Transmisión Automática de 9 velocidades",
            "Tracción integral 4X4",
            "Interior tapizado de cuero",
            "Rodado 18''",
            "Parrila frontal cromada",
          ],
          colores: [
            { file: laramieAzul, color: colores.azul },
            { file: laramieBranco, color: colores.blanco },
            { file: laramieDiamond, color: colores.negro },
            { file: laramieCinza, color: colores.gris },
            { file: laramiePrata, color: colores.plata },
            { file: laramieRojo, color: colores.rojo },
            { file: laramieSteel, color: colores.grisOscuro },
          ],
        },
      ],
      ficha: "https://montironijeep.com/wp-content/uploads/2024/01/Rampage-RT.pdf",
    },
    {
      modelo: "LARAMIE NIGHT EDITION",
      id: "LARAMIE NIGHT EDITION",
      types: [
        {
          title: "LARAMIE NIGHT EDITION",
          specs: [
            "Motorización Hurricane4 2.0 Turbo 272Cv | 400 Nm",
            "Transmisión Automática de 9 velocidades",
            "Tracción integral 4X4",
            "Interior tapizado de cuero",
            "Rodado 18'' oscurecidas",
            "Parrila frontal color Negro",
          ],
          colores: [
            { file: nightAzul, color: colores.azul },
            { file: nightBlanco, color: colores.blanco },
            { file: nightNegro, color: colores.negro },
            { file: nightgris, color: colores.gris },
            { file: nightPlata, color: colores.plata },
          ],
        },
      ],
      ficha: "https://montironijeep.com/wp-content/uploads/2024/01/Rampage-RT.pdf",
    },
  ];

  const [selectedModel, setSelectedModel] = useState("REBEL");
  const [selectedItem, setSelectedItem] = useState();
  const [selectedItem2, setSelectedItem2] = useState();
  const [selectedItem3, setSelectedItem3] = useState();
  const [selectedItem4, setSelectedItem4] = useState();
  const [selectedColor, setSelectedColor] = useState();
  const [selectedColor2, setSelectedColor2] = useState();
  const [selectedColor3, setSelectedColor3] = useState();
  const [selectedColor4, setSelectedColor4] = useState();

  useEffect(() => {
    setSelectedItem(models.find((t) => t.modelo === "REBEL"));
    setSelectedItem2(models.find((t) => t.modelo === "RT"));
    setSelectedItem3(models.find((t) => t.modelo === "LARAMIE"));
    setSelectedItem4(models.find((t) => t.modelo === "LARAMIE NIGHT EDITION"));
  }, [selectedModel]);

  useEffect(() => {
    setSelectedColor(selectedItem?.types[0]?.colores[0]);
    setSelectedColor2(selectedItem2?.types[0]?.colores[5]);
    setSelectedColor3(selectedItem3?.types[0]?.colores[4]);
    setSelectedColor4(selectedItem4?.types[0]?.colores[0]);
  }, [selectedItem]);

  return (
    <Container className="pt-5 pb-5" id="versiones">
      <Row>
        {
          //MOBILE
        }
        <Col className="d-md-none d-block mx-auto" md={12}>
          <TabModelo item={models[1]} selectedColor={selectedColor2} setSelectedColor={setSelectedColor2} />

          <TabModelo item={models[0]} selectedColor={selectedColor} setSelectedColor={setSelectedColor} />

          <TabModelo item={models[2]} selectedColor={selectedColor3} setSelectedColor={setSelectedColor3} />

          <TabModelo item={models[3]} selectedColor={selectedColor4} setSelectedColor={setSelectedColor4} />
        </Col>
        {
          //DESKTOP
        }
        <Col className="d-md-block d-none mx-auto" id="modelos" md={9}>
          <Row className="d-flex justify-content-between">
            <TabModelo item={models[1]} selectedColor={selectedColor2} setSelectedColor={setSelectedColor2} />
            <TabModelo item={models[0]} selectedColor={selectedColor} setSelectedColor={setSelectedColor} />
          </Row>
          <Row className="d-flex justify-content-between">
            <TabModelo item={models[2]} selectedColor={selectedColor3} setSelectedColor={setSelectedColor3} />
            <TabModelo item={models[3]} selectedColor={selectedColor4} setSelectedColor={setSelectedColor4} />
          </Row>
        </Col>
      </Row>
      <div id="form"></div>
    </Container>
  );
};

export default Modelos;
